import ReasonRejectionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection/reason-rejection.entity';
import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'app/core/auth/services/auth.service';
import { ReasonRejectionService } from '../../master/reason-for-rejection/reason-rejection.service';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { environment } from 'environments/environment.prod';
import { OrdersListService } from '../../sales/order-list-components/order-list.service';
import { DocumentClassAttributes } from '@albatrosdeveloper/ave-models-package';
import { TypeRejectEnum } from './type-document.enum';
import { DocumentTypeEnum } from 'app/common/enums/document-types.enum';

@Component({
  selector: 'app-form-appro-reject',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    MatFormFieldModule,
    MatLabel,
    MatRadioModule,
    TextFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './form-appro-reject.component.html',
  styleUrl: './form-appro-reject.component.scss'
})
export class FormApproRejectComponent {
  TypeRejectEnum = TypeRejectEnum
  public id: any = null
  loadSave = false

  isTypeConditional: boolean = true
  selectOption = null
  showComment = false
  comment = null
  showRejection = false
  reasonRejectionId = null
  documentClassId = null
  quantityCredit: number
  
  reasonRejectionList: ReasonRejectionAttributes[] = [];
  filteredReasonRejectionList = this.reasonRejectionList;
  searchReasonRejection: string = '';

  documentClassesApproveList: DocumentClassAttributes[] = [];
  filteredDocumentClassesApproveList: DocumentClassAttributes[] = [];
  searchDocumentClass: string = '';

  @ViewChild("confirmDialog") confirmDialog!: TemplateRef<any>;
  
  constructor(
    private readonly reasonRejectionService: ReasonRejectionService,
    private readonly ordersListService: OrdersListService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<FormApproRejectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    this.isTypeConditional = this.data.type == TypeRejectEnum.PEDIDO || this.data.type == TypeRejectEnum.COTIZACION ? false : true //Pedido, Cotizacion no tiene
    this.selectOption = this.data.requeriment ? (this.data.requeriment.approve ? 'A': this.data.requeriment.approve_generate ? 'D' : 'R') : null
    if(this.selectOption == 'R'){
      this.onSelectOption('R')
    }
    if(this.selectOption == 'A' && this.data.type == TypeRejectEnum.SOLICITUD_CREDITO){
      this.showComment = true;
    }

    this.fetchDocumentClassToApprove()
    this.fetchReasonRejections()

    this.quantityCredit = this.data.element.amountCreditRequested || 0
  }

  getActions(): string[] {
    const requeriment = this.data?.requeriment || {};
    const { approve, reject, approve_generate } = requeriment;
    return [
      approve && 'Aprobar',
      reject && 'Rechazar',
      approve_generate && 'Aprobar y Generar sgte. documento'
    ].filter(Boolean);
  }
  
  getDialogTitle(): string {
    const actions = this.getActions();
    return actions.length ? actions.join(' / ') : 'Acción no definida';
  }
  
  getProcessText(): string {
    return this.getActions().length > 1 ? '¿Qué proceso desea seguir?' : 'Proceso a continuar';
  }
  
  onClose() {
    this.dialogRef.close('Close')
  }

  onSelectOption(item){
    this.selectOption = item
    if(item == 'R'){
      this.showComment = true
      this.showRejection = true
    }else{
      this.showComment = this.data.type == TypeRejectEnum.SOLICITUD_CREDITO ? true : false;
      this.comment = null
      this.showRejection = false
      this.reasonRejectionId = null
      this.documentClassId = null
    }
  }

  openConfirmDialog(): void {
    this.dialog
      .open(this.confirmDialog, { data: null, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.onSubmit());
  }

  onSubmit(){
    if(!this.selectOption){
      return
    }

    if(this.isTypeConditional && this.selectOption == 'R' && (this.comment == null || this.comment == '')){
      this.snackBar.open("Ingrese un comentario", "Cerrar", { duration: 3000 });
      return
    }

    if(this.selectOption == 'R' && (this.reasonRejectionId == null)){
      this.snackBar.open("Seleccione un motivo", "Cerrar", { duration: 3000 });
      return
    }

    if(this.selectOption == 'D' && (this.documentClassId == null)){
      this.snackBar.open("Seleccione una clase de documento", "Cerrar", { duration: 3000 });
      return
    }

    this.loadSave = true

    if(!this.authService.user){
      return
    }

    let send = {
      id: this.data.element._id,
      email: this.authService.user.email,
      username: this.authService.user.username,
      reasonRejectionId: this.reasonRejectionId,
      rejectedReason: this.data.type === TypeRejectEnum.SOLICITUD_CREDITO ? this.comment : this.selectOption == 'R' ? this.comment : null,
      approve: this.selectOption == 'A' ? true : false, //1-> aprobado, 0 -> rechazado
      approve_document: this.selectOption == 'D' ? true : false, //solo para la opcion sgte documento
      documentClassId: this.documentClassId,
      quantityCredit: this.selectOption == 'A' ? this.quantityCredit: null
    }

    this.dialogRef.close(send)
    this.loadSave = false
  }

  //filter
  fetchReasonRejections() {
    this.reasonRejectionService.findToComboBox(this.data.type).subscribe({
      next: (res) => {
        this.reasonRejectionList = res.data;
        this.filteredReasonRejectionList = this.reasonRejectionList;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los motivos de cancelación.","Cerrar",{ duration: 3000 }
        );
      },
    });
  }

  changueOptionRejection(event) {
    if (!this.reasonRejectionList) {
      return;
    }
    let search = event;
    if (!search) {
      this.filteredReasonRejectionList = this.reasonRejectionList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredReasonRejectionList = this.reasonRejectionList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }

  private fetchDocumentClassToApprove(): void {
    let dataToFilter = {
      type: DocumentTypeEnum.PEDIDO,
    }

    this.ordersListService.fetchDocumentClasses(dataToFilter).subscribe((res) => {
      this.documentClassesApproveList = res.data;
      this.filteredDocumentClassesApproveList = this.documentClassesApproveList.slice();
    });
  }

  changueOptionDocumentClasses(event) {
    if (!this.documentClassesApproveList) {
      return;
    }
    let search = event;
    if (!search) {
      this.filteredDocumentClassesApproveList = this.documentClassesApproveList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDocumentClassesApproveList = this.documentClassesApproveList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }

  validateQuantity() {
    if (this.quantityCredit > this.data.element.amountCreditRequested) {
      this.quantityCredit = this.data.element.amountCreditRequested
    }
  }
}


